export class ServiceConflicAlert {
    serviceOne = null;
    serviceTwo = null;
}